import { useCallback } from 'react'

import { requestRichRelevanceTracking } from 'catalog/services/track-rich-relevance'

import {
  ExpressDeliveryTag,
  PriceTag,
  ProductImage,
  ProductInfo
} from './components'
import AssistedSaleContentManager from '../ProductThumb/components/assisted-sale/AssistedSaleContentManager'
import * as S from './styled'

const NewProductThumb = ({
  product,
  position = 0,
  variableWidth = false,
  shouldShowNewReviewsRating = false,
  onClick = () => {},
  reviewRating = { avgRating: '0', totalReviewsCount: 0 },
  isLoadingReview
}) => {
  const {
    id,
    shortName,
    picture,
    unit,
    inWishList,
    installments,
    isOutlet = false,
    tag,
    offer,
    price,
    discount,
    url,
    trackingUrl = null,
    assistedSale,
    isSoldOut,
    isExpressDelivery,
    expressDeliveryDay,
    name,
    services,
    brand,
    categoryTree
  } = product
  const isPromotional = Boolean(offer)
  const isDiscountByPaymentMethod = Boolean(
    discount && discount.discountType === 'payment-method'
  )
  const typeClass = offer ? `type-${offer.type}` : ''
  const soldOutClass = isSoldOut ? 'type-soldout' : ''
  const productThumbClass = `new-product-thumb ${typeClass} ${soldOutClass}`

  const handleWrapperClick = useCallback(
    event => {
      event.preventDefault()
      const anchorElement = event.target.closest('a')

      const trackClickAndGoToUrl = async () => {
        if (trackingUrl && anchorElement) {
          await requestRichRelevanceTracking(trackingUrl)
        }

        onClick()

        if (anchorElement) {
          window.location.href = url
        }
      }

      trackClickAndGoToUrl()
    },
    [onClick, trackingUrl, url]
  )

  return (
    <S.Wrapper
      variableWidth={variableWidth}
      className={productThumbClass}
      onClick={handleWrapperClick}
      itemScope
      itemProp="product"
      itemType="https://schema.org/Product"
    >
      <div>
        <ProductImage
          name={name}
          brand={brand}
          category={categoryTree}
          id={id}
          tag={tag}
          url={url}
          offer={offer}
          picture={picture}
          shortName={shortName}
          inWishList={inWishList}
          assistedSale={assistedSale}
          price={price}
          onHeartClick={onClick}
        />
        <ProductInfo
          id={id}
          url={url}
          name={name}
          shortName={shortName}
          hasServiceBadge={services}
          reviewRating={reviewRating}
          isLoadingReview={isLoadingReview}
          shouldShowNewReviewsRating={shouldShowNewReviewsRating}
        />
      </div>
      <div>
        <AssistedSaleContentManager
          {...product}
          isMobileContext={false}
          price={price}
        />
        {isExpressDelivery && (
          <ExpressDeliveryTag
            isPromotional={isPromotional}
            isSoldOut={isSoldOut}
            deliveryDate={expressDeliveryDay}
          />
        )}
        <PriceTag
          price={price}
          unit={unit}
          installments={installments}
          url={url}
          shortName={shortName}
          isSoldOut={isSoldOut}
          isOutlet={isOutlet}
          isPromotional={isPromotional}
          isDiscountByPaymentMethod={isDiscountByPaymentMethod}
          paymentMethodsDiscount={discount.paymentMethodsDiscount}
        />
      </div>
      <meta itemProp="position" content={position} />
    </S.Wrapper>
  )
}

export default NewProductThumb
